import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {CartService} from "../../../../service/cart";
import {ApiService} from "../../../../service/api";

@Component({
    selector: 'paypal-dialog',
    templateUrl: './paypal.component.html',
    styleUrls: ['./paypal.component.css']
})
export class PayPalDialog implements OnInit, AfterViewInit {

    public total: any;
    public payment: any;
    public purchase: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public cart: CartService, public api: ApiService,
                public dialogRef: MatDialogRef<PayPalDialog>) {
        this.payment = data.payment;
        this.total = data.total;
        this.purchase = data.purchase;
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        let subtotal = this.total.subtotal,
            shipping = this.total.shipping,
            handling_fee = this.total.handling_fee,
            total = this.total.total,
            paypal = window['paypal'];

        paypal.Button.render({

            env: 'production',
            locale: 'de_AT',

            client: {
                sandbox: 'AYsSu4T2NAv-pPRE0Erbl3InfOhNJc6G3oGf6jqPPJSzPMcGrhOjeWLeahho8EIVD5Qg8nU1cpE72wtB',
                production: 'ATGl0cpLGtj4MMwJqZ0HUDSEmS76XGBp0z9R-Jd6PkM6n0v7FF6Fyu_DNIZtpJUqrLpsCD1sr_Pm_9zk'
            },

            commit: true, // Show a 'Pay Now' button

            payment: (data, actions) => {
                return actions.payment.create({
                    payment: {
                        transactions: [
                            {
                                amount: {
                                    total: total,
                                    currency: 'EUR',
                                    details: {
                                        subtotal: subtotal,
                                        shipping: shipping,
                                        handling_fee: handling_fee
                                    }
                                }
                            }
                        ]
                    }
                });
            },

            onAuthorize: (data, actions) => {
                return actions.payment.execute().then((payment) => {
                    this.api.call('/checkout/index/pay', {
                        purchase: this.purchase
                    }).then(() => {
                        this.dialogRef.close();
                    });
                });
            },

            onCancel: function (data) {
            }

        }, '#paypal-button');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/checkout/dialog/paypal/paypal.component.ts